module.exports = __webpack_public_path__ + "static/media/17.c449c9d4.png";